import { useDispatch } from "react-redux";

import { sendClickToContactCTA } from "../../../actions";
import {
  contactListingAgent,
  setExpertInfo
} from "../../../slices/contactFormSlice";
import { useContactFormData } from "../useContactFormData";

export const useContactFormBehavior = () => {
  const dispatch = useDispatch();
  const {
    expertsApiUuid,
    fromSource,
    listingId,
    propertyAddress
  } = useContactFormData();

  return {
    contactListingAgent: formData =>
      dispatch(
        contactListingAgent({
          ...formData,
          expertsApiUuid,
          fromSource,
          listingId,
          propertyAddress
        })
      ),
    sendClickToContactCTA: () =>
      dispatch(sendClickToContactCTA({ fromSource })),
    setExpertInfo: data => dispatch(setExpertInfo(data))
  };
};
